//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	props: {
		items: {
			type: Array,
			required: true,
			validator: function validator(val) {
				return val.length;
			}
		}
	},

	data: function data() {
		return {
			swiperOptions: {
				slidesPerView: 2,
				centeredSlides: true,
				spaceBetween: 32,
				loop: true,

				speed: 2000,
				autoplay: {
					delay: 5000
				},

				breakpoints: {
					620: {
						slidesPerView: 'auto',
						centeredSlides: false,
						spaceBetween: 16
					},

					1024: {
						slidesPerView: 'auto',
						spaceBetween: 32
					}
				}
			}
		};
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/ProductLineCarousel.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/ProductLineCarousel.vue
// module chunks = 0